const STEPS = Object.freeze(["Claimed", "Rendered", "Verifying", "Settled"]);

const PRESENTATIONS = Object.freeze({
  claimed: {
    label: "Rendering",
    tone: "active",
    detail: "Claim secured. The output still needs to be submitted.",
    activeStep: 1
  },
  submitted: {
    label: "Verifying",
    tone: "warning",
    detail: "Output submitted. Awaiting verifier quorum.",
    activeStep: 2
  },
  rejected: {
    label: "Rejected",
    tone: "danger",
    detail: "Verifier quorum rejected this output, so no worker reward was released.",
    activeStep: 3,
    terminal: "failed"
  },
  expired: {
    label: "Expired",
    tone: "danger",
    detail: "The job expired before settlement, so no worker reward was released.",
    activeStep: 3,
    terminal: "failed"
  }
});

export function getWorkerJobPresentation(job) {
  const acceptedPresentation = job?.settlementMode === "onchain"
    ? job?.settlementTransactionHash
      ? {
          label: "Reward ready",
          tone: "success",
          detail: "On-chain settlement is confirmed. Withdraw any ready rewards above.",
          activeStep: 3,
          terminal: "complete"
        }
      : {
          label: "Settlement pending",
          tone: "warning",
          detail: "Verifier quorum accepted this output. The on-chain payout transaction is still pending.",
          activeStep: 3
        }
    : {
        label: "Paid",
        tone: "success",
        detail: "Verifier quorum accepted this output and credits were added directly to this identity.",
        activeStep: 3,
        terminal: "complete"
      };
  const presentation = job?.state === "accepted" ? acceptedPresentation : PRESENTATIONS[job?.state] || {
    label: String(job?.state || "Unknown").replaceAll("_", " "),
    tone: "muted",
    detail: "Coordinator state is available, but this client does not recognize it yet.",
    activeStep: 0
  };
  return {
    ...presentation,
    detail: job?.state === "rejected" && job?.rejectionReason
      ? job.rejectionReason
      : presentation.detail,
    lifecycle: STEPS.map((label, index) => ({
      label,
      state: presentation.terminal && index === presentation.activeStep
        ? presentation.terminal
        : index < presentation.activeStep || (presentation.terminal === "complete" && index === presentation.activeStep)
          ? "complete"
          : index === presentation.activeStep ? "active" : "pending"
    }))
  };
}
